import PropTypes from 'prop-types';
import React from 'react';
import SnackbarLib from 'react-md/lib/Snackbars';
import { connect } from 'react-redux';
import { removeToastAndAddToastFromQueue } from 'actions/snackbar';

export const Snackbar = ({ toasts, autohide, className, removeToast }) => (
  <SnackbarLib
    toasts={toasts}
    autohide={autohide}
    autohideTimeout={3000}
    className={className}
    onDismiss={removeToast} />
);

const mapStateToProps = (state) => {
  return {
    toasts: state.snackbar.toasts,
    autohide: state.snackbar.autohide,
    className: state.snackbar.className
  };
};

const mapDispatchToProps = (dispatch) => ({
  removeToast() {
    dispatch(removeToastAndAddToastFromQueue());
  }
});

Snackbar.propTypes = {
  toasts: PropTypes.array.isRequired,
  autohide: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  removeToast: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Snackbar);
